/**
 * Metadata de secciones del sidebar.
 * Cada board manifest referencia su section por nombre.
 */
export const SECTIONS = [
  {
    name: "ALUNA",
    roles: [
      "Authenticated",
      "aluna",
      "aluna-management",
      "aluna-comercial",
      "aluna-branding",
      "design",
      "design-roundler",
      "master-aluna-rrss",
      "roundler-admin",
      "aluna-afiliado",
    ],
    groups: {
      CSM: {
        order: 9,
        roles: ["Authenticated", "aluna", "aluna-management"],
      },
      COMERCIAL: {
        order: 10,
        roles: ["Authenticated", "aluna-management", "aluna-comercial"],
      },
    },
  },
  {
    name: "ROUNDLER",
    roles: [
      "Authenticated",
      "roundler-admin",
      "design",
      "design-roundler",
      "master-rrss-roundler",
      "master-aluna-rrss",
      "aluna",
    ],
    groups: {},
  },
  {
    name: "HOP",
    roles: [
      "Authenticated",
      "hop",
      "hop-management",
      "hop-publisher-partnerships",
    ],
    groups: {},
  },
  {
    name: "IONVO",
    roles: [
      "Authenticated",
      "roundler-admin",
      "aluna",
      "aluna-management",
      "hop-management",
      "design",
      "design-roundler",
      "aluna-afiliado",
    ],
    groups: {},
  },
  {
    name: "COMPAO",
    roles: [
      "Authenticated",
      "design",
      "design-roundler",
      "master-rrss-roundler",
      "master-aluna-rrss",
      "roundler-admin",
      "aluna",
    ],
    groups: {},
  },
  {
    name: "CLIENTS",
    roles: ["Clients"],
    groups: {},
  },
];
